import PropTypes from 'prop-types';
import { discountType } from './discount-types';

export const declineReasonType = PropTypes.string;

export const incomeRequestRecordType = PropTypes.shape({
  methods: PropTypes.arrayOf(PropTypes.string),
  plaidItemUuids: PropTypes.arrayOf(PropTypes.string),
  uuid: PropTypes.string,
  vendor: PropTypes.string,
});

export const discountListType = PropTypes.shape({
  discount: discountType,
  rateWithDiscount: PropTypes.number,
});

export const offerType = PropTypes.shape({
  baseRate: PropTypes.number,
  discountList: PropTypes.arrayOf(discountListType),
  id: PropTypes.string,
  index: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  originationFeePercentage: PropTypes.number,
  rateWithAllDiscounts: PropTypes.number,
  rateType: PropTypes.string,
  term: PropTypes.number,
});

export const offerByTypeType = PropTypes.shape({
  min: PropTypes.number,
  max: PropTypes.number,
  offers: PropTypes.arrayOf(offerType),
  rateType: PropTypes.string,
  termsList: PropTypes.arrayOf(PropTypes.number),
});

export const offerPackageType = PropTypes.shape({
  applicationUuid: PropTypes.string,
  creditUnion: PropTypes.string,
  declineReasons: PropTypes.arrayOf(declineReasonType),
  decision: PropTypes.string,
  disabledIncomeSources: PropTypes.arrayOf(PropTypes.string),
  hasMultipleOriginationFees: PropTypes.bool,
  incomeResultRecordUuids: PropTypes.arrayOf(PropTypes.string),
  incomeRequestRecords: PropTypes.arrayOf(incomeRequestRecordType),
  offersByType: PropTypes.arrayOf(offerByTypeType),
  plaidItemUuids: PropTypes.arrayOf(PropTypes.string),
  statedTotalIncome: PropTypes.number,
  subDecision: PropTypes.string,
  verifiedIncomeRequestUuid: PropTypes.string,
  verifiedTotalIncome: PropTypes.number,
});
